<template>
  <div class="">
    <div class="flex s-bt mb-chart">
      <!-- 버튼 그룹 Y1 -->
      <div class="flex">
        <button
          v-for="button in filterBtnY1"
          :key="button.value"
          :title="button.title"
          @click="selectValue(button.value, 'y1')"
          :class="{ active: y1Value === button.value, [button.activeClass]: y1Value === button.value }"
          :style="{ backgroundColor: y1Value === button.value ? getColor(button.value) : '' }"
        >
          <img :src="button.icon" class="button-chart-icon" />
        </button>
      </div>

      <!-- 버튼 그룹 Y2 -->
      <div class="flex" style="justify-content:end;">
        <button
          v-for="button in filterBtnY2"
          :key="button.value"
          :title="button.title"
          @click="selectValue(button.value, 'y2')"
          :class="{ active: y2Value === button.value, [button.activeClass]: y2Value === button.value }"
          :style="{ backgroundColor: y2Value === button.value ? getColor(button.value) : '' }"
        >
          <img :src="button.icon" class="button-chart-icon" />
        </button>
      </div>
    </div>
    <!-- 차트 영역 -->
    <div class="chart__layout">
      <div class="flex s-bt">
        <span class="label">{{ getLabel(y1Value) }}</span>
        <span class="label">{{ getLabel(y2Value) }}</span>
      </div>
      <canvas 
        ref="chartCanvas" 
        :style="chartSize" 
        :width="width" 
        :height="height">
      </canvas>
    </div>
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LineElement, PointElement, LinearScale, CategoryScale, BarController, LineController, Filler, Decimation, ArcElement } from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,   
  BarElement,    
  PointElement,
  LinearScale,    
  CategoryScale,
  BarController, 
  LineController, 
  Filler,
  Decimation,
  ArcElement
);

export default {
  name: 'ButtonChart',
  props: {
    services: {
      type: Object,
      required: true
    },
    chartTypeY1: {
      type: String,
      default: 'Line', // 기본값 설정
      validator: value => ['Bar', 'Line'].includes(value),
    },
    chartTypeY2: {
      type: String,
      default: 'Line', // 기본값 설정
      validator: value => ['Bar', 'Line'].includes(value),
    },
    // chartType: {
    //   type: String,
    //   required: true,
    //   validator: value => ['Bar', 'Line'].includes(value) 
    // },
    buttonsY1: {
      type: Array,
      required: true
    },
    buttonsY2: {
      type: Array,
      required: true
    },
    y1DefaultValue: String,
    y2DefaultValue: String,
    chartSize: {
      type: Object,
      required: true
    },
    trendData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    }
  },
  watch: {
    trendData: {
      handler(newData) {
        if (newData.time_temp && newData.time_temp.length > 0) {
          this.renderChart();
        }
      },
      deep: true
    },
    chartData: {
      handler(newValue, oldValue) {
        // 데이터가 바뀌었을 때만 차트를 다시 그리기
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.renderChart();
        }
      },
      deep: true
    },
    chartOptions: {
      handler(newValue, oldValue) {
        // 옵션이 바뀌었을 때만 차트를 다시 그리기
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.renderChart();
        }
      },
      deep: true
    },
    y1DefaultValue(newVal) {
      this.y1Value = newVal;
      this.renderChart();
    },
    y2DefaultValue(newVal) {
      this.y2Value = newVal;
      this.renderChart();
    }
  },
  data() {
    return {
      y1Value: this.y1DefaultValue, 
      y2Value: this.y2DefaultValue,
      chartInstance: null
    };
  },
  computed: {
    filterBtnY1() {
      if (!this.trendData || Object.keys(this.trendData).length === 0) {
        return this.buttonsY1.filter(button => button.value !== 'w_temp' || this.term !== 0);
      }

      return this.buttonsY1.filter(button => 
        this.trendData[button.value] && this.trendData[button.value].length > 0
      );
    },

    filterBtnY2() {
      if (!this.trendData || Object.keys(this.trendData).length === 0) {
        return this.buttonsY2.filter(button => button.value !== 'w_temp' || this.term !== 0);
      }

      return this.buttonsY2.filter(button => 
        this.trendData[button.value] && this.trendData[button.value].length > 0
      );
    },

    // filterBtnY1() {
    //   // if (!this.services || !this.trendData) return [];

    //   if (!this.services || Object.keys(this.services).length === 0) {
    //     return this.buttonsY1.filter(button => button.value !== 'w_temp' || this.term !== 0);
    //   }

    //   // 기존 로직: services와 trendData를 기반으로 필터링
    //   return this.buttonsY1.filter(button => {
    //     const services = this.services.deodorizer
    //       ? ['temp', 'hum', 'w_temp', 'co2', 'nh3', 'h2s'].includes(button.value)
    //       : this.services.fancontrol
    //       ? ['temp', 'hum', 'w_temp', 'co2', 'nh3'].includes(button.value)
    //       : ['temp', 'hum', 'w_temp'].includes(button.value);
        
    //     const data = this.trendData[button.value] && this.trendData[button.value].length > 0;
        
    //     return services && data;
    //   });
    // },
    // filterBtnY2() {
    //   if (!this.services || Object.keys(this.services).length === 0) {
    //     return this.buttonsY2.filter(button => button.value !== 'w_temp' || this.term !== 0);
    //   }

    //   return this.buttonsY2.filter(button => {
    //     const services = this.services.deodorizer
    //       ? ['temp', 'hum', 'w_temp', 'co2', 'nh3', 'h2s'].includes(button.value)
    //       : this.services.fancontrol
    //       ? ['temp', 'hum', 'w_temp', 'co2', 'nh3'].includes(button.value)
    //       : ['temp', 'hum', 'w_temp'].includes(button.value);
        
    //     const data = this.trendData[button.value] && this.trendData[button.value].length > 0;
        
    //     return services && data;
    //   });
    // },
    computedChartData() {
      if (!this.trendData || !this.trendData[`time_${this.y1Value}`]) {
        return { labels: [], datasets: [] };
      }
      return {
        labels: this.trendData[`time_${this.y1Value}`],
        datasets: [
          {
            label: this.getLabel(this.y2Value),
            data: this.trendData[this.y2Value],
            borderColor: this.getColor(this.y2Value),
            fill: false,
            type: this.chartTypeY2.toLowerCase(),
            yAxisID: 'y2'
          },  
          {
            label: this.getLabel(this.y1Value),
            data: this.trendData[this.y1Value],
            borderColor: this.getColor(this.y1Value),
            backgroundColor: this.chartTypeY1 === 'Bar' ? "#FFF1CA" : undefined,
            fill: this.chartTypeY1 === 'Bar',
            barPercentage: this.chartTypeY1 === 'Bar' ? 0.8 : undefined,
            borderRadius: this.chartTypeY1 === 'Bar' ? 10 : undefined,
            type: this.chartTypeY1.toLowerCase(), 
            yAxisID: 'y1'
          }
        ]
      };

    }
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    renderChart() {
      this.destroyChart();

      const ctx = this.$refs.chartCanvas.getContext('2d');
      this.chartInstance = new ChartJS(ctx, {
        type: this.chartTypeY1 ? this.chartTypeY1.toLowerCase() : 'line',
        // type: this.chartType.toLowerCase(),
        data: this.computedChartData,
        options: this.chartOptions
      });
    },
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    selectValue(value, axis) {
      if (axis === 'y1') this.y1Value = value;
      else if (axis === 'y2') this.y2Value = value;
      this.updateChart();
    },
    updateChart() {
      this.chartInstance.data = this.computedChartData;
      this.chartInstance.update();
    },
    getLabel(value) {
      switch (value) {
        case 'watt': return '전력량 kWh';
        case 'temp': return '온도 ℃';
        case 'w_temp': return '외기온도 ℃';
        case 'hum': return '습도 %';
        case 'co2': return '이산화탄소 ppm';
        case 'nh3': return '암모니아 ppm';
        case 'h2s': return '황화수소 ppm';
        case 'pres': return '기압 hPa';
        case 'wind': return '풍속 m/s';
        default: return '';
      }
    },
    getColor(value) {
      switch (value) {
        case 'watt': return '#FFF1CA';
        case 'temp': return '#8CC0DE';
        case 'w_temp': return '#51829B'; 
        case 'hum': return '#CCEEBC';
        case 'co2': return '#8EDBE7';
        case 'nh3': return '#FFD6A5';
        case 'h2s': return '#D4E2D4';
        case 'pres': return '#a8d9f6';
        case 'wind': return  '#1a659e';
        default: return '';
      }
    }
  },
};
</script>

<style lang="scss" scoped>

button {
  margin-right: 5px;
  padding: 5px 5px;
  border-radius: 10px;
  width:50px;
  /* border: 1px solid #191a88; */
  color:#191a88;
  /* color: white; */
  cursor: pointer;
}
button:hover {
  background-color:#eaeaea;
  transition: all 0.5s ease;
}
button.active {
  /* background-color: #191a88; */
  color:white;
  border:none;
}
.button-chart-icon{
  margin-top:3px;
  width: 30px !important;
  height: 25px !important;
}
.chart__layout{
  margin-top:5px;
  padding:10px 20px 40px 20px;
  height: 30vh;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}
.label{
  background-color: #E7EDFD;
  font-weight:500;
  letter-spacing: -1px;
  padding:5px;
  border-radius: 5px;
}
@media screen and (max-width: 768px) {
.mb-chart{
  flex-direction: column;
}
.watt_active{
  display: none !important;
}
}
</style>